import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";

// import images
import logo from "../../assets/images/logo-light.png";
import logoDark from "../../assets/images/logo-dark.png";
import { useRecoilValue } from "recoil";
import { themeTypeState } from '../../state/GlobalState';
import { FaqContent } from '../../custom/components/FaqContent';
import { getActiveFaqRequest } from '../../api/controller/EventController';

/**
 * Public FAQ for the active event. Expo volunteers are not given accounts but
 * field the same questions as the issuers, so this page needs no login and
 * always follows whichever event is active.
 */
const Faq = () => {
    const [loading, setLoading] = useState(true);
    const [faq, setFaq] = useState("");
    const [eventName, setEventName] = useState("");
    const [error, setError] = useState("");
    const themeType = useRecoilValue(themeTypeState);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const response = await getActiveFaqRequest();
                if (cancelled) return;
                if (response?.Status === 'success') {
                    setFaq(response.Data?.Faq || "");
                    setEventName(response.Data?.EventName || "");
                } else {
                    setError("Could not load the FAQ. Please try again.");
                }
            } catch (err) {
                if (! cancelled) setError("Could not load the FAQ. Please try again.");
            } finally {
                if (! cancelled) setLoading(false);
            }
        };
        load();
        return () => { cancelled = true };
    }, []);

    return (
        <React.Fragment>
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <div className="p-4">
                        <div className="text-center mb-4">
                            <div className="d-flex justify-content-center">
                                <img
                                    src={themeType === 'dark' ? logo : logoDark}
                                    alt="irunners-logo"
                                    width="200px"
                                    className='logo-light'
                                />
                            </div>
                        </div>

                        <Row className="justify-content-center">
                            <Col md={10} lg={8}>
                                <Card style={{ border: '1px solid' }}>
                                    <CardHeader>
                                        <h4 className="text-center mb-0">
                                            FAQ{eventName ? ' - ' + eventName : ''}
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        {error ? (
                                            <div className="text-danger text-center py-4">{error}</div>
                                        ) : (
                                            <FaqContent loading={loading} faq={faq} />
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Faq;
